(function () {
  'use strict';
  var COOKIE = 'geo_popup_dismissed', CACHE_KEY = 'mk_geo_detected', COOKIE_DAYS = 30, els = {}, CFG = null, REGION = null;
  try { REGION = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function getCookie(n) { var m = document.cookie.match('(?:^|;)\\s*' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(n, v, d) { var t = new Date(); t.setTime(t.getTime() + d * 864e5); document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + t.toUTCString() + ';path=/;SameSite=Lax'; }
  function track(ev, detail) { try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'mk_geo_' + ev, mk_geo: detail || {} }); } catch (e) {} }
  function isoToFlag(iso) { if (!iso || iso.length !== 2) return ''; var A = 0x1F1E6, u = iso.toUpperCase(); return String.fromCodePoint(A + u.charCodeAt(0) - 65) + String.fromCodePoint(A + u.charCodeAt(1) - 65); }
  function enName(iso, fb) { if (REGION && iso && iso.length === 2) { try { var n = REGION.of(iso.toUpperCase()); if (n) return n; } catch (e) {} } return fb || iso; }
  function openModal() { if (els.root) { els.root.classList.add('is-open'); els.root.setAttribute('aria-hidden', 'false'); } }
  function dismiss() { if (els.root) { els.root.classList.remove('is-open'); els.root.setAttribute('aria-hidden', 'true'); } setCookie(COOKIE, 'true', COOKIE_DAYS); track('dismissed', {}); }
  function fetchJson(u) { return fetch(u, { mode: 'cors' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function detect(cb) {
    try { var c = sessionStorage.getItem(CACHE_KEY); if (c) { cb(JSON.parse(c)); return; } } catch (e) {}
    fetchJson('https://api.country.is/').then(function (d) {
      if (d && d.country) return { iso: d.country };
      return fetchJson('https://ipapi.co/json/').then(function (d2) { return (d2 && d2.country_code) ? { iso: d2.country_code } : null; });
    }).then(function (out) { if (out) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(out)); } catch (e) {} } cb(out); });
  }
  function cache() {
    els.root = document.getElementById('mk-geo');
    els.flag = document.getElementById('mk-geo-flag');
    els.eyebrow = document.getElementById('mk-geo-eyebrow');
    els.headingCountry = document.getElementById('mk-geo-heading-country');
    els.text = document.getElementById('mk-geo-text');
    els.primary = document.getElementById('mk-geo-switch');
    els.countryInput = document.getElementById('mk-geo-country-input');
    els.localeInput = document.getElementById('mk-geo-locale-input');
    els.countrySelect = document.getElementById('mk-geo-country-select');
    els.languageSelect = document.getElementById('mk-geo-language-select');
    els.form = document.getElementById('mk-geo-form');
  }
  function setHeading(eyebrow, main) { if (els.eyebrow) { els.eyebrow.textContent = eyebrow || ''; els.eyebrow.style.display = eyebrow ? 'block' : 'none'; } if (els.headingCountry) els.headingCountry.textContent = main || ''; }
  function setText(t) { if (els.text) els.text.textContent = t; }
  function setPrimary(t) { if (els.primary) els.primary.textContent = t; }
  function setFlag(iso) { if (els.flag) els.flag.textContent = isoToFlag(iso); }

  function rootFor(iso) { if (CFG && CFG.languages) { for (var i = 0; i < CFG.languages.length; i++) { if (CFG.languages[i].iso === iso) { var r = CFG.languages[i].root; return (typeof r === 'string' && r.charAt(0) === '/') ? r : '/'; } } } return '/'; }
  function cleanSearch() { var s = location.search || ''; if (!s) return ''; var parts = s.replace(/^[?]/, '').split('&').filter(function (p) { return p && p.indexOf('mk_geo=') !== 0; }); return parts.length ? '?' + parts.join('&') : ''; }
  function localePath(locale) {
    var path = location.pathname || '/';
    var cr = rootFor(CFG.currentLanguage);
    if (cr !== '/' && (path === cr || path.indexOf(cr + '/') === 0)) { path = path.slice(cr.length) || '/'; }
    if (path.charAt(0) !== '/') path = '/' + path;
    var root = rootFor(locale);
    var base = (root && root !== '/') ? root : '';
    return base + path + cleanSearch() + location.hash;
  }

  function fillCountries(selectedIso) {
    if (!els.countrySelect || els.countrySelect.dataset.filled) return;
    var list = CFG.countries.slice().sort(function (a, b) { return enName(a.iso, a.name).localeCompare(enName(b.iso, b.name)); });
    list.forEach(function (c) {
      var o = document.createElement('option'); o.value = c.iso;
      o.textContent = isoToFlag(c.iso) + '  ' + enName(c.iso, c.name);
      if (c.iso.toUpperCase() === (selectedIso || '').toUpperCase()) o.selected = true;
      els.countrySelect.appendChild(o);
    });
    els.countrySelect.dataset.filled = '1';
  }
  function fillLanguages(selectedIso) {
    if (!els.languageSelect || !CFG.languages || els.languageSelect.dataset.filled) return;
    CFG.languages.forEach(function (l) {
      var o = document.createElement('option'); o.value = l.iso; o.textContent = l.name;
      if (l.iso === selectedIso) o.selected = true;
      els.languageSelect.appendChild(o);
    });
    els.languageSelect.dataset.filled = '1';
    if (els.localeInput && selectedIso) els.localeInput.value = selectedIso;
  }
  function defaultLocale() { var e = findEnglish(); return e ? e.iso : CFG.currentLanguage; }
  function wire() {
    if (els.countrySelect && !els.countrySelect.dataset.wired) {
      els.countrySelect.dataset.wired = '1';
      els.countrySelect.addEventListener('change', function () {
        var iso = els.countrySelect.value, name = enName(iso);
        if (els.countryInput) els.countryInput.value = iso;
        setFlag(iso); setHeading('Shopping from', name + '?'); setPrimary('Continue to ' + name);
      });
    }
    if (els.languageSelect && !els.languageSelect.dataset.wired) {
      els.languageSelect.dataset.wired = '1';
      els.languageSelect.addEventListener('change', function () { if (els.localeInput) els.localeInput.value = els.languageSelect.value; });
    }
    if (els.root && !els.root.dataset.wired) {
      els.root.dataset.wired = '1';
      Array.prototype.forEach.call(els.root.querySelectorAll('[data-mk-geo-dismiss]'), function (d) { d.addEventListener('click', dismiss); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && els.root.classList.contains('is-open')) dismiss(); });
    }
    if (els.form && !els.form.dataset.wired) {
      els.form.dataset.wired = '1';
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var selCountry = els.countrySelect ? els.countrySelect.value : (els.countryInput ? els.countryInput.value : CFG.currentCountry);
        var selLocale = els.languageSelect ? els.languageSelect.value : CFG.currentLanguage;
        var target = localePath(selLocale);
        var go = function () { window.location.assign(target); };
        setCookie(COOKIE, 'true', COOKIE_DAYS);
        track('switch_clicked', { country: selCountry, locale: selLocale });
        var countryChanged = selCountry && selCountry.toUpperCase() !== (CFG.currentCountry || '').toUpperCase();
        if (countryChanged) {
          try {
            var fd = new FormData(els.form);
            fd.set('country_code', selCountry); fd.set('locale_code', selLocale); fd.set('return_to', target);
            fetch('/localization', { method: 'POST', body: fd, credentials: 'same-origin' }).then(go, go);
          } catch (err) { go(); }
        } else { go(); }
      });
    }
  }

  function showMatch(iso) {
    var name = enName(iso);
    setFlag(iso); setHeading('Shopping from', name + '?');
    setText('Browse in your preferred language for the best Myriam•K experience.');
    setPrimary('Continue to ' + name);
    if (els.countryInput) els.countryInput.value = iso;
    fillCountries(iso); fillLanguages(defaultLocale()); wire();
    openModal(); track('shown', { mode: 'market', country: iso });
  }
  function showEnglish(detIso, english) {
    setFlag(detIso); setHeading('', 'Welcome to Myriam•K Paris');
    setText('We don’t have a dedicated store for your region yet — browse our international store in English.');
    setPrimary('Continue in English');
    if (els.countryInput) els.countryInput.value = CFG.currentCountry;
    if (els.localeInput) els.localeInput.value = english.iso;
    fillCountries(CFG.currentCountry); fillLanguages(english.iso); wire();
    openModal(); track('shown', { mode: 'english_fallback', detected: detIso });
  }

  // Manual open — reuses the SAME modal, form, styles & market switching. Bypasses cookie/mismatch guards.
  function openManually() {
    if (!els.root) return;
    if (!CFG) { var c = document.getElementById('mk-geo-config'); if (c) { try { CFG = JSON.parse(c.textContent); } catch (e) { return; } } }
    if (!CFG || !CFG.countries) return;
    fillCountries(CFG.currentCountry);
    fillLanguages(CFG.currentLanguage);
    if (els.countrySelect) els.countrySelect.value = CFG.currentCountry;
    if (els.languageSelect) els.languageSelect.value = CFG.currentLanguage;
    if (els.countryInput) els.countryInput.value = CFG.currentCountry;
    if (els.localeInput) els.localeInput.value = CFG.currentLanguage;
    setFlag(CFG.currentCountry);
    setHeading('', 'Country & language');
    setText('Choose where you’d like to shop and your preferred language.');
    setPrimary('Continue to ' + enName(CFG.currentCountry));
    wire();
    openModal();
    track('opened_manually', {});
  }

  function lookup(iso) { if (!iso) return null; iso = iso.toUpperCase(); for (var i = 0; i < CFG.countries.length; i++) { if (CFG.countries[i].iso.toUpperCase() === iso) return CFG.countries[i]; } return null; }
  function findEnglish() { if (!CFG || !CFG.languages) return null; for (var i = 0; i < CFG.languages.length; i++) { var iso = (CFG.languages[i].iso || '').toLowerCase(); if (iso === 'en' || iso.indexOf('en-') === 0) return CFG.languages[i]; } return null; }
  function firstNonCurrent() { for (var i = 0; i < CFG.countries.length; i++) { if (CFG.countries[i].iso.toUpperCase() !== (CFG.currentCountry || '').toUpperCase()) return CFG.countries[i].iso; } return CFG.countries[0].iso; }

  function autoInit() {
    if (!els.root) return;
    if (!CFG) { var c = document.getElementById('mk-geo-config'); if (c) { try { CFG = JSON.parse(c.textContent); } catch (e) { return; } } }
    if (!CFG || !CFG.countries || CFG.countries.length < 2) return;
    var force = /[?&]mk_geo=(1|test|show)/.test(location.search);
    if (!force && getCookie(COOKIE) === 'true') return;
    if (force) { try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {} }

    detect(function (detected) {
      var detIso = detected && detected.iso ? detected.iso.toUpperCase() : '';
      var cur = (CFG.currentCountry || '').toUpperCase();
      if (detIso && detIso !== cur && lookup(detIso)) { showMatch(detIso); return; }
      var english = findEnglish();
      var curEn = (CFG.currentLanguage || '').toLowerCase().indexOf('en') === 0;
      if (detIso && detIso !== cur && english && !curEn) { showEnglish(detIso, english); return; }
      if (force) {
        if (detIso) {
          if (lookup(detIso)) showMatch(detIso);
          else if (english) showEnglish(detIso, english);
          else showMatch(detIso);
        } else { showMatch(firstNonCurrent()); }
      }
    });
  }

  ready(function () {
    cache();
    var cfgEl = document.getElementById('mk-geo-config');
    if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = null; } }

    // Public API + menu triggers (always available, even when the auto-popup is suppressed).
    window.MKGeo = window.MKGeo || {};
    window.MKGeo.open = openManually;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.js-open-market-selector,[data-open-market-selector],a[href$="#change-locale"]') : null;
      if (t) { e.preventDefault(); openManually(); }
    });
    var checkHash = function () { if (location.hash === '#change-locale') openManually(); };
    window.addEventListener('hashchange', checkHash);
    checkHash();

    // Automatic behavior — unchanged.
    if ('requestIdleCallback' in window) requestIdleCallback(autoInit, { timeout: 3000 }); else setTimeout(autoInit, 1200);
  });
})();